let backendHost;

const hostname = window && window.location && window.location.hostname;

if (hostname === 'localhost') {
    backendHost = 'http://localhost:9090';
} else if (hostname === 'staff.jug.thewebpeople.ca') {
    backendHost = 'https://staff.jug.thewebpeople.ca';
} else {
    backendHost = 'https://staff.jug.ca';
}

export const API_ROOT = `${backendHost}/api`;